import { render } from "./NoahLoader.vue?vue&type=template&id=2cdab415&scoped=true"
import script from "./NoahLoader.vue?vue&type=script&lang=js"
export * from "./NoahLoader.vue?vue&type=script&lang=js"

import "./NoahLoader.vue?vue&type=style&index=0&id=2cdab415&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdab415"]])

export default __exports__